import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api, { apiError } from "../lib/api";

export function ProfileContent() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", whatsapp: user?.whatsapp || "", address: user?.address || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [b1, setB1] = useState(false);
  const [b2, setB2] = useState(false);

  const saveProfile = async (e) => {
    e.preventDefault();
    setB1(true);
    try {
      const { data } = await api.put("/auth/profile", form);
      setUser(data);
      toast.success("Profil diperbarui");
    } catch (err) { toast.error(apiError(err)); } finally { setB1(false); }
  };

  const changePw = async (e) => {
    e.preventDefault();
    setB2(true);
    try {
      await api.put("/auth/change-password", pw);
      setPw({ current_password: "", new_password: "" });
      toast.success("Password berhasil diubah");
    } catch (err) { toast.error(apiError(err)); } finally { setB2(false); }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl">
      <form onSubmit={saveProfile} className="card p-6 space-y-4">
        <h3 className="font-heading font-bold text-slate-900">Informasi Profil</h3>
        <div><label className="text-sm font-medium text-slate-700">Nama</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input mt-1" data-testid="profile-name" /></div>
        <div><label className="text-sm font-medium text-slate-700">Email</label><input value={user?.email} disabled className="input mt-1 bg-slate-50 text-slate-400" /></div>
        <div><label className="text-sm font-medium text-slate-700">No. WhatsApp</label><input value={form.whatsapp} onChange={(e) => setForm({ ...form, whatsapp: e.target.value })} className="input mt-1" data-testid="profile-whatsapp" /></div>
        <div><label className="text-sm font-medium text-slate-700">Alamat</label><textarea rows={2} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="input mt-1" data-testid="profile-address" /></div>
        <button type="submit" disabled={b1} className="btn-primary" data-testid="profile-save">{b1 ? <Loader2 className="h-4 w-4 animate-spin" /> : "Simpan Perubahan"}</button>
      </form>

      <form onSubmit={changePw} className="card p-6 space-y-4">
        <h3 className="font-heading font-bold text-slate-900">Ubah Password</h3>
        <div><label className="text-sm font-medium text-slate-700">Password Lama</label><input type="password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="input mt-1" data-testid="pw-current" /></div>
        <div><label className="text-sm font-medium text-slate-700">Password Baru</label><input type="password" required value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="input mt-1" data-testid="pw-new" /></div>
        <button type="submit" disabled={b2} className="btn-primary" data-testid="pw-save">{b2 ? <Loader2 className="h-4 w-4 animate-spin" /> : "Ubah Password"}</button>
      </form>
    </div>
  );
}
